import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: (failureCount, error) => {
                // Don't retry on client errors (4xx) - they are not transient
                const status = error?.response?.status;
                if (status >= 400 && status < 500) {
                    return false;
                }
                // Don't retry proxy timeouts (Cloudflare 524, gateway 504): the origin
                // is still processing the request, so a retry only multiplies the load
                if (status === 504 || status === 524) {
                    return false;
                }
                // Default: retry up to 3 times for server errors (5xx) and network errors
                return failureCount < 3;
            },
        },
    },
});
